import { render, staticRenderFns } from "./CommissionLogScreen.vue?vue&type=template&id=2491e0f6"
import script from "./CommissionLogScreen.vue?vue&type=script&lang=js"
export * from "./CommissionLogScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports